/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module EmailValidationModule */

import { Injectable } from '@angular/core';
import { AlbHttpClient } from 'ng/modules/http/service/alb-http-client.service';
import { ISysTestEmailParams } from 'generated-types';
import { Observable } from 'rxjs';
import { EmailModalTypeEnum } from './email-validation-modal.component';

/**
 * @description Service to validate emails.
 * @author Manideep Kotha
 */
@Injectable()
export class EmailValidationService {
    constructor(private readonly http: AlbHttpClient) {}

    public fetchData(
        uuid: string,
        data: ISysTestEmailParams,
        emailModalType: EmailModalTypeEnum,
    ): Observable<object> {
        const apiHash = {
            smtp: '/api/testemail',
            email: `/api/alertemailconfig/${uuid}/testemail`,
            snmp: `/api/snmptrapprofile/${uuid}/testsnmptrap`,
            syslog: `/api/alertsyslogconfig/${uuid}/testsyslog`,
        };

        return this.http.post(
            apiHash[emailModalType],
            data,
        );
    }
}
